// Registers the PWA service worker and surfaces the beforeinstallprompt event
// so any component (e.g. <InstallPrompt />) can show a custom Install button.
// The deferred prompt lives on `window.__itiInstallPrompt` until consumed.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only register in production-style hosts. The webpack-dev-server in CRA also
  // works fine with a service worker since the SW is served from /public.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[iti-sw] register failed:", err));
  });

  // Capture the install prompt so the UI can trigger it on demand
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__itiInstallPrompt = e;
    window.dispatchEvent(new CustomEvent("iti-install-available"));
  });

  // Track successful installs so we can dismiss the prompt
  window.addEventListener("appinstalled", () => {
    window.__itiInstallPrompt = null;
    window.dispatchEvent(new CustomEvent("iti-install-completed"));
  });
}
